<template>
    <div class="page seasonalList"  @scroll="pageScroll" ref="page">
        <div class="pageContainer">
            <div class="container">
                <h2 class="d-flex justify-content-between align-items-center">
                    <img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)" alt="back">
                    <span v-if="getLng() == 'en'">Past Collections</span>
                    <span v-else>Colecciones Pasadas</span>
                    <span style="width: 35px"></span>
                </h2>
                
                <div class="list mt-5">
                    <div class="listItem" v-for="filter in getSeasonal.children">
                        <router-link :to="{name:'recipes', query: { filter: filter.id }}">
                            <div class="listIContainer">
                                <div class="imgBox">
                                    <img class="img-fluid" :src="filter.image ? filter.image : getStaticImage('logo.png')" :blur="0"></img>
                                </div>
                                <span  v-if="getLng() == 'en'">{{filter.name}}</span>
                                <span  v-else>{{filter.spanish_name}}</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import pageMixin from "../mixins/page";

    export default {
        name: "RecipesList",
        mixins: [pageMixin],
        data() {
            return {
                seasanol: null
            }
        },
        mounted(){
            this.changePageTitle("Seasonal Cocktail Recipes | ABM Cocktail Pro");
        },
        methods: {
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }
        },
        computed: {
            ...mapState("search", ["filters"]),
            getSeasonal(){
                return this.filters.children.find( el => el.slug==='seasonal')
            }
        },
    }
</script>
